import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { STORAGE_KEYS } from '../../shared/utils/constants';
import rolesApi from '../../features/roles/services/rolesApi';

export const fetchUserRoles = createAsyncThunk('roles/fetchUserRoles', async (userId) => {
  return await rolesApi.getUserRoles(userId);
});

export const assignRole = createAsyncThunk('roles/assignRole', async ({ userId, participantType }) => {
  await rolesApi.assignRole(userId, participantType);
  return participantType;
});

export const removeRole = createAsyncThunk('roles/removeRole', async ({ userId, participantType }) => {
  await rolesApi.removeRole(userId, participantType);
  return participantType;
});

export const switchActiveRole = createAsyncThunk('roles/switchActiveRole', async (participantType) => {
  await rolesApi.setActiveRole(participantType);
  return participantType;
});

const savedRole = sessionStorage.getItem(STORAGE_KEYS.ACTIVE_PARTICIPANT_ROLE);

const rolesSlice = createSlice({
  name: 'roles',
  initialState: {
    activeRole: savedRole || null,
    availableRoles: [],
    loading: false,
    error: null,
  },
  reducers: {
    setActiveRole: (state, action) => {
      state.activeRole = action.payload;
      sessionStorage.setItem(STORAGE_KEYS.ACTIVE_PARTICIPANT_ROLE, action.payload);
    },
    setAvailableRoles: (state, action) => {
      state.availableRoles = action.payload;
    },
    clearRoles: (state) => {
      state.activeRole = null;
      state.availableRoles = [];
      sessionStorage.removeItem(STORAGE_KEYS.ACTIVE_PARTICIPANT_ROLE);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserRoles.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchUserRoles.fulfilled, (state, action) => {
        state.loading = false;
        state.availableRoles = action.payload.roles || [];
        if (action.payload.activeRole) {
          state.activeRole = action.payload.activeRole;
          sessionStorage.setItem(STORAGE_KEYS.ACTIVE_PARTICIPANT_ROLE, action.payload.activeRole);
        } else if (!state.activeRole && state.availableRoles.length > 0) {
          state.activeRole = state.availableRoles[0];
          sessionStorage.setItem(STORAGE_KEYS.ACTIVE_PARTICIPANT_ROLE, state.availableRoles[0]);
        }
      })
      .addCase(fetchUserRoles.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(assignRole.fulfilled, (state, action) => {
        if (!state.availableRoles.includes(action.payload)) {
          state.availableRoles.push(action.payload);
        }
      })
      .addCase(removeRole.fulfilled, (state, action) => {
        state.availableRoles = state.availableRoles.filter(r => r !== action.payload);
        if (state.activeRole === action.payload) {
          state.activeRole = state.availableRoles[0] || null;
          if (state.activeRole) sessionStorage.setItem(STORAGE_KEYS.ACTIVE_PARTICIPANT_ROLE, state.activeRole);
          else sessionStorage.removeItem(STORAGE_KEYS.ACTIVE_PARTICIPANT_ROLE);
        }
      })
      .addCase(switchActiveRole.fulfilled, (state, action) => {
        state.activeRole = action.payload;
        sessionStorage.setItem(STORAGE_KEYS.ACTIVE_PARTICIPANT_ROLE, action.payload);
      });
  },
});

export const { setActiveRole, setAvailableRoles, clearRoles } = rolesSlice.actions;
export default rolesSlice.reducer;
